"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitPackagingReportHeader = void 0;
const enums_1 = require("../../sales-order/enums");
const models_1 = require("../models");
class ShippingKitPackagingReportHeader {
}
exports.ShippingKitPackagingReportHeader = ShippingKitPackagingReportHeader;
//# sourceMappingURL=shipping-kit-packaging-report-header.response.js.map